import { ApiService }     from '../../app-lite/api/api.service';
import { SessionService } from '../../app-lite/sessions/session.service';

import StockTakeHtml from './stock-take.html';

export function StockTakeStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'StockTakeCtrl',
    name       : 'app.stock-take',
    templateUrl: StockTakeHtml,
    url        : '/stock_take',
    resolve    : {
      product_types: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/stock_take_product_types'),
      session      : ( sessionObjAPI : SessionService ) : ng.IPromise<any> => sessionObjAPI.refresh(),
      beginProduct : ( gridAPI : any, sessionObjAPI : SessionService, workshopAPI : ApiService ) : ng.IPromise<any> => {
        const preferences = gridAPI.getPreferences('stocktakeGrid');

        return sessionObjAPI.user().cache_grid_filters && preferences.filtering.begin_item && preferences.filtering.begin_item !== '*'
          ? workshopAPI.get('/product', preferences.filtering.begin_item)
          : null;
      },
      endProduct: ( gridAPI : any, sessionObjAPI : SessionService, workshopAPI : ApiService) : ng.IPromise<any> => {
        const preferences = gridAPI.getPreferences('stocktakeGrid');

        return sessionObjAPI.user().cache_grid_filters && preferences.filtering.end_item && preferences.filtering.end_item !== '*'
          ? workshopAPI.get('/product', preferences.filtering.end_item)
          : null;
      },
      locations: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/products/locations'),
      products : ( gridAPI : any, sessionObjAPI : SessionService, workshopAPI : ApiService) : ng.IPromise<any> => {
        const cacheGridFilters = sessionObjAPI.user().cache_grid_filters;
        const preferences      = gridAPI.getPreferences('stocktakeGrid');
        const group            = cacheGridFilters && preferences.filtering.product_group ? preferences.filtering.product_group : '*';

        return workshopAPI.get('/stock_takes', [
          cacheGridFilters && preferences.filtering.product_type ? preferences.filtering.product_type : 'S',
          cacheGridFilters && preferences.filtering.vendor ? preferences.filtering.vendor : '*',
          cacheGridFilters && preferences.filtering.begin_item ? preferences.filtering.begin_item : '*',
          cacheGridFilters && preferences.filtering.end_item ? preferences.filtering.end_item : '*',
          cacheGridFilters && preferences.filtering.location ? preferences.filtering.location : '*',
          preferences.sorting.fields[0] || 'item_code',
          preferences.sorting.directions[0] || 'asc',
          0,
          (preferences.paging.pageSize + 1) || 11,
          preferences.filtering.hide_zeros || false,
          preferences.filtering.count_excludes_reserved || false
        ], null, { query: { group } });
      },
      product_groups: ( $q : ng.IQService, workshopAPI : ApiService ) : ng.IPromise<any> => {
        const deferred = $q.defer();

        workshopAPI.get('/product_groups').then(function (groups) {
          groups.push({ name: '*' });

          deferred.resolve(groups);
        }).catch(function (err) {
          deferred.reject(err);
        });

        return deferred.promise;
      },
      vendor: ( gridAPI : any, sessionObjAPI : SessionService, workshopAPI : ApiService) : ng.IPromise<any> => {
        const preferences = gridAPI.getPreferences('stocktakeGrid');

        return sessionObjAPI.user().cache_grid_filters && preferences.filtering.vendor && preferences.filtering.vendor !== '*'
          ? workshopAPI.get('/vendor', preferences.filtering.vendor)
          : null;
      }
    }
  });
};